import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';

const BASE_API = process.env.REACT_APP_BASE_API;

interface IAnyResponse {
  [key: string]: any;
}

interface IGetSingleNewPayload {
  singleNewId: string | number | undefined;
  lang: string;
}

interface IGetNewsPayload {
  page: number;
  lang: string;
}

export const newsSlice = createApi({
  reducerPath: 'news',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = (getState() as RootState).isAuth.isAuth;
      const lang = (getState() as RootState).language.lang;
      const publicEndpoints = ['getNews', 'getSingleNew'];
      const isPublic = publicEndpoints.includes(endpoint);
      if (token && !isPublic) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Accept-Language', lang);
      return headers;
    }
  }),
  tagTypes: ['News'],
  endpoints: (builder) => ({
    getNews: builder.query<IAnyResponse, IGetNewsPayload>({
      query: (payload) => ({
        url: `/articles?page=${payload.page}`,
        method: 'GET'
      })
    }),

    getSingleNew: builder.query<IAnyResponse, IGetSingleNewPayload>({
      query: (payload) => ({
        url: `/article/${payload.singleNewId}`,
        method: 'GET'
      })
    })
  })
});

export const { useGetSingleNewQuery, useGetNewsQuery } = newsSlice;
